import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then( m => m.HomePageModule)
  },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'vehiculo',
    loadChildren: () => import('./pages/vehiculo/vehiculo.module').then( m => m.VehiculoPageModule)
  },
  {
    path: 'modal-document',
    loadChildren: () => import('./pages/modal-document/modal-document.module').then( m => m.ModalDocumentPageModule)
  },
  {
    path: 'orden',
    loadChildren: () => import('./pages/orden/orden.module').then( m => m.OrdenPageModule)
  },
  {
    path: 'historial',
    loadChildren: () => import('./pages/orden/historial/historial.module').then( m => m.HistorialPageModule)
  },
  {
    path: 'ruta',
    loadChildren: () => import('./pages/orden/ruta/ruta.module').then( m => m.RutaPageModule)
  },
  {
    path: 'otsuspender',
    loadChildren: () => import('./pages/orden/suspender/suspender.module').then( m => m.SuspenderPageModule)
  },

  {
    path: 'documentacion',
    loadChildren: () => import('./pages/documentacion/documentacion.module').then( m => m.DocumentacionPageModule)
  },  {
    path: 'ots',
    loadChildren: () => import('./pages/ots/ots.module').then( m => m.OtsPageModule)
  },

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
